export default  {
    navMenus: state => state.account.navMenus, // 导航菜单
    navMap: state => state.account.navMap,
    employee: state => state.account.employee, // 导航菜单
    notifyConnect: state => state.account.connect, // 导航菜单
    factoryProductNames: state => state.factory.productNames, // 导航菜单
    buttons: state => state.account.buttons, // 导航菜单
}
